import { useCallback, useEffect, useState } from 'react';
import ExamImageZoom from './ExamImageZoom';
import ExamImage from './ExamImage';

const useImgSize = imgUrl => {
	const [imgSize, setImgSize] = useState();
	const imgLoadCb = useCallback(
		(err, img) => {
			if (err === null) {
				setImgSize({ width: img.naturalWidth, height: img.naturalHeight });
			}
		},
		[setImgSize]
	);

	useEffect(() => {
		if (imgUrl !== null) {
			const img = new Image();
			img.onload = () => imgLoadCb(null, img);
			img.onerror = imgLoadCb;
			img.src = imgUrl;
		}
	}, [imgUrl]);
	return imgSize;
};

function ExamImageComponent(props) {
	const { HeaderComponent, LayerComponent } = props;
	const { value, onChange } = props.field;
	const { imageUrl } = props.fieldConfig;
	const imgFullUrl = imageUrl + value;
	//const imgFullUrl = 'assets/images/tesztlap.jpg';
	const imgSize = useImgSize(imgFullUrl);
	const [zoomLevel, setZoomLevel] = useState(0);

	return (
		<div className="rounded-8 border px-16 pt-10 pb-4 mb-16">
			<div className="flex flex-col">
				<div className="flex flex-row">
					<ExamImageZoom zoomLevel={zoomLevel} onChange={v => setZoomLevel(v)} />
					{HeaderComponent && <HeaderComponent />}
				</div>
			</div>
			<div className="border-1 my-10" />
			{imgSize && <ExamImage imgUrl={imgFullUrl} imgKey={value} zoomLevel={zoomLevel} imgSize={imgSize} LayerComponent={LayerComponent} />}
		</div>
	);
}
export default ExamImageComponent;
